import { useNavigate } from "react-router-dom";
import errorImage from "assets/icon/icon_error.svg";
import "./notfound.scss";

export default function NotFoundView() {
  const navigate = useNavigate();
  return (
    <>
      {/* <Heade /> */}
      <section className="not-find">
        <div className="pb-[20px]">
          <img src={errorImage} alt="느낌표" />
        </div>
        <div className="flex col text-center">
          <h1 className="py-3">요청하신 페이지를 찾을 수 없습니다.</h1>
          <p className="text-sm leading-[28px] font-bold">
            방문하시려는 페이지의 주소가 잘못 입력되었거나,
            <br /> 페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수
            없습니다.
            <br /> 입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.
          </p>
          <div className="flex justify-center gap-4 pt-4">
            <button className="btn" onClick={() => navigate(-1)}>
              이전페이지로
            </button>
            <button
              className="btn"
              onClick={() => navigate("/", { replace: true })}
            >
              메인으로
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
